import { useTranslation } from "react-i18next";
import { Checkbox } from "antd";

const LevelBox = ({
  data,
  handleFilterSelection,
  isFiltersLoadingInline,
  selectedFilters,
}) => {
  const { t, i18n } = useTranslation("common");
  const isEn = i18n.language === "en";

  const handleCancelCheck = (e) => {
    e?.stopPropagation();
    const value = e?.target?.value;
    const isChecked = e?.target?.checked;

    handleFilterSelection("levels", value, isChecked);
  };

  return (
    <article className="w-full border-t-green border-t-4 py-3 lg:px-5 px-4 border rounded-2xl">
      <h3 className="font-bold text-lg mb-[10px]">
        {t("search.filter_Vorkenntnisse")}
      </h3>

      {data?.map((level) => (
        <Checkbox
          key={level?.alias + level?.count}
          className="search_checkbox w-full mb-[8px] !ml-[2px]"
          onChange={handleCancelCheck}
          disabled={isFiltersLoadingInline}
          value={level?.alias}
          checked={selectedFilters?.includes(level?.alias)}
        >
          <p
            className={`text-base text-left ${
              selectedFilters?.includes(level?.alias)
                ? "font-medium"
                : "font-normal"
            }`}
          >
            {isEn
              ? level?.title_en ?? level?.title_de
              : level?.title_de ?? level?.title_en}
            {level?.count && ` (${level?.count})`}
          </p>
        </Checkbox>
      ))}
    </article>
  );
};

export default LevelBox;
